import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const FounderSection = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const items = sectionRef.current.querySelectorAll('.founder-step')
    gsap.set(items, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        gsap.to(items, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: 'power3.out',
        })
      },
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="founder-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2 className="founder-title gold-text">Becoming a Founder</h2>
        <p className="founder-subtext">
          To access <strong>BrandHub</strong> and create campaigns:
        </p>
        <div className="founder-steps">
          <div className="founder-step">
            <div className="step-bar" />
            <div className="step-content">
              <h4 className="step-title">Application Process</h4>
              <p className="step-description">
                Founders must complete an application that includes an <strong>AML/KYC (Anti-Money Laundering/Know Your Customer)</strong> verification process.
              </p>
            </div>
          </div>
          <div className="founder-step" style={{marginLeft: '1rem'}}>
            <div className="step-bar" />
            <div className="step-content">
              <h4 className="step-title">Approval</h4>
              <p className="step-description">
                Once verified, Founders are granted access to BrandHub to launch crowdfunding campaigns and issue RWA Tickets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FounderSection
